<template>
    <TopMenu id="top_menu"/>
    <div
        :class="hasHeaderBanner ? 'pt-[135px] lg:pt-[200px]':'pt-[60px] lg:pt-[60px]'"
        class="grid gap-3 min-h-screen mx-auto grid-cols-10 xl:grid-cols-12 laptopXL_1:flex"
    >
        <!--        <div class="lg:col-span-2 lg:pb-6 xl:col-span-2 w-[226px] pl-4 my-8 lg:block hidden bg-white z-20">-->
        <!--            <SideMenu class=""/>-->

        <!--        </div>-->
        <transition
            enter-active-class="transition ease-in-out duration-200"
            enter-from-class="opacity-0 ease-in-out duration-200" enter-to-class="opacity-100 ease-in-out duration-200"
            leave-active-class="transition ease-in-out duration-200"
            leave-from-class="opacity-100 ease-in-out duration-200" leave-to-class="opacity-0 ease-in-out duration-200"
        >
            <div
                v-show="globalState.openMainSideMenu || laptopXL_1" id="main_side_menu_close" ref="menuContainer"
                class="lg:col-span-2 lg:pb-6 xl:col-span-2 w-[226px] pl-4 my-8 lg:block bg-white z-[40] h-full laptopXL_1:fixed laptopXL_1:top-[163px] laptop:top-[136px] tabletDefault:top-[118px] mobileXXL:top-[102px] mobile:top-[90px] laptopXL_1:bg-[rgba(0,0,0,0.4)] laptopXL_1:pl-0 laptopXL_1:mt-0 laptopXL_1:w-full"
            >
                <SideMenu
                    containerClass="tabletDefault:max-w-full laptopXL_1:bg-white laptopXL_1:absolute laptopXL_1:top-0 laptopXL_1:max-w-[23.4375rem] laptopXL_1:pt-4 laptopXL_1:px-4 laptopXL_1:h-[calc(100%-163px)] laptop:h-[calc(100%-136px)] tabletDefault:h-[calc(100%-118px)] mobileXXL:h-[calc(100%-102px)] mobile:h-[calc(100%-90px)]"
                >
                    <template v-if="!laptopXL_1" v-slot:sideMenuFooter>
                        <MainFooter class="mt-3 mb-4"/>
                    </template>
                </SideMenu>
            </div>
        </transition>
        <div
            id="main_frame"
            class="col-span-10 w-full lg:col-span-8 xl:col-span-10 3xl:ml-[-212px] 3xl:justify-self-center max-w-[1512px] p-3 sm:p-6 relative"
        >
            <slot/>
        </div>
        <!-- <div class="col-span-10 w-full lg:col-span-8 2xl:ml-[-212px] xl:col-span-10 max-w-[1126px] justify-self-center min-h-screen p-6" id="main_frame">
			<slot />
		</div> -->
    </div>
    <!-- <app-footer /> -->

</template>
<script setup>
import TopMenu from '@/Layouts/Menu/TopMenu.vue';
import SideMenu from '@/Layouts/Menu/SideMenu.vue';
// import AppFooter from '@/Layouts/Menu/AppFooter.vue';
import { usePage } from '@inertiajs/vue3';
import { inject, onBeforeUnmount, onMounted, onUnmounted, ref, computed } from 'vue';
import { useWindowDimensions } from '@/Pages/Main/helpers/dimentions.ts';
import MainFooter from '@/Pages/Main/Components/MainFooter.vue';

const page = usePage();
const { laptopXL_1 } = useWindowDimensions();

const prevPage = localStorage.getItem('prevPage');
let isNavigating = false;
const globalState = inject('globalState');
const handleUrlChange = () => {
    if (isNavigating) {
        isNavigating = false;
    }
};

const handleNavigationStart = (event) => {
    const target = event.target;
    if (target.tagName === 'A' && target.href) {
        isNavigating = true;
        localStorage.removeItem('prevPage');
    }
};

const menuContainer = ref(null);
const handleClickOutside = (event) => {
    const clickedElementId = event.target.id;
    if (globalState.openMainSideMenu && (clickedElementId === 'main_side_menu_close' || clickedElementId === 'top_menu_close')) {
        globalState.openMainSideMenu = false;
    }
};

onMounted(() => {
    document.addEventListener('click', handleClickOutside);
    document.addEventListener('click', handleNavigationStart);
    window.addEventListener('popstate', handleBackButton);
    window.addEventListener('pushstate', handleUrlChange);
});

onBeforeUnmount(() => {
    localStorage.removeItem('prevPage');
    document.removeEventListener('click', handleClickOutside);
    document.removeEventListener('click', handleNavigationStart);
    window.removeEventListener('popstate', handleUrlChange);
    window.removeEventListener('pushstate', handleUrlChange);
});

onUnmounted(() => {
    localStorage.removeItem('prevPage');
});

onUnmounted(() => {
    globalState.openMainSideMenu = false;
});

const handleBackButton = () => {

    if (prevPage === 'main') {
        window.location.assign('/');
        localStorage.removeItem('prevPage');
    }
};

const hasHeaderBanner = computed(() => {
    return page.props.banners?.some(b => b.location === 'header' && b.is_active);
});

// export default {
//     Components: { topMenu, sideMenu, appFooter },
//     data() {
//         return {
//             url: '',
//             page: usePage(),
//         };
//     },
//     watch: {
//         url: {
//             handler(newValue, old){
//                 // console.log('colors changed', newValue, old)
//                 this.recordHistory();
//             }, deep: true
//         }
//     },
//     created() {
//         this.url = window.location.pathname;
//     },
//     methods: {
//         recordHistory() {
//             let history = localStorage.getItem('history') ? JSON.parse(localStorage.getItem('history')) : new Array();
//             history.unshift(window.location.pathname);
//             if (history.length > 2) {
//                 history.splice(2);
//             }
//             // console.log('history', history);
//
//             localStorage.history = JSON.stringify(history);
//         }
//     }
// };
</script>
